import React from "react";
import { motion } from "framer-motion";
import { Award, HeartPulse, Scale, Leaf } from "lucide-react";

const CARDS = [
  { icon: Award, title: "Quality", body: "Delivering medicines that meet the highest pharmaceutical standards — batch by batch, molecule by molecule." },
  { icon: HeartPulse, title: "Patients", body: "Improving lives through safe, effective, and accessible healthcare solutions engineered around the patient." },
  { icon: Scale, title: "Ethics", body: "Transparent and ethical business practices with every partner, doctor, distributor and stakeholder." },
  { icon: Leaf, title: "Sustainability", body: "Working towards a healthier planet with responsible manufacturing and mindful growth." },
];

export default function Responsibility() {
  return (
    <section id="responsibility" className="py-24 sm:py-32 px-6 sm:px-10 lg:px-10 relative">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-28">
          <div className="section-eyebrow" data-testid="responsibility-eyebrow">Responsibility</div>
          <h2 className="mt-3 font-display text-4xl sm:text-5xl font-semibold tracking-tight text-slate-900" data-testid="responsibility-heading">
            Our <span className="text-gradient">Responsibility</span>.
          </h2>
          <p className="mt-5 text-slate-600 leading-relaxed">
            Every decision at Andrich is guided by four commitments — the quiet standards behind
            our products, our people and our purpose.
          </p>
          <div className="mt-8 rounded-2xl overflow-hidden border border-slate-200">
            <img
              src="https://images.unsplash.com/photo-1421789665209-c9b2a435e3dc?crop=entropy&cs=srgb&fm=jpg&w=900&q=85"
              alt="Sustainability"
              className="w-full h-64 object-cover"
            />
          </div>
        </div>

        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5 lg:gap-6">
          {CARDS.map((c, i) => (
            <motion.article
              key={c.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="group bg-white border border-slate-200 rounded-2xl p-7 hover:-translate-y-1.5 hover:shadow-xl transition-[transform,box-shadow] duration-300"
              data-testid={`responsibility-card-${c.title.toLowerCase()}`}
            >
              <div className="h-12 w-12 rounded-xl bg-gradient-to-br from-green-600 to-blue-900 text-white flex items-center justify-center shadow-md">
                <c.icon size={20} />
              </div>
              <h3 className="mt-6 font-display text-xl font-semibold text-slate-900">{c.title}</h3>
              <p className="mt-3 text-sm text-slate-600 leading-relaxed">{c.body}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
